/** Turn raw fetch / gateway / JSON dumps into short copy safe for the UI. */
export function toUserErrorMessage(
  input: unknown,
  fallback = "Something went wrong. Try again.",
): string {
  let status: number | undefined;
  let raw = "";

  if (input && typeof input === "object" && "status" in input && "body" in input) {
    const err = input as { status?: number; body?: string; message?: string };
    status = typeof err.status === "number" ? err.status : undefined;
    raw = String(err.body ?? err.message ?? "");
  } else if (input instanceof Error) {
    raw = input.message;
  } else if (typeof input === "string") {
    raw = input;
  }

  const text = raw.trim();
  const lower = text.toLowerCase();

  if (
    status === 502 ||
    status === 503 ||
    status === 504 ||
    lower.includes("bad gateway") ||
    lower.includes("origin_bad_gateway") ||
    lower.includes("error 502") ||
    lower.includes("cloudflare")
  ) {
    return "Service is temporarily unavailable. Please try again in a minute.";
  }

  if (status === 429 || lower.includes("too many")) {
    return "Too many attempts. Wait a moment and try again.";
  }

  if (typeof status === "number" && status >= 500) {
    return "Something went wrong on our side. Please try again.";
  }

  if (
    lower.includes("network request failed") ||
    lower.includes("failed to fetch") ||
    lower.includes("network error")
  ) {
    return "Could not reach the server. Check your connection and try again.";
  }

  if (!text) return fallback;

  if (
    text.startsWith("{") ||
    text.startsWith("[") ||
    text.startsWith("<") ||
    lower.includes("<!doctype") ||
    lower.includes("ray_id") ||
    lower.includes("\"error_name\"")
  ) {
    try {
      const parsed = JSON.parse(text) as { error?: unknown; message?: unknown };
      if (typeof parsed.error === "string" && parsed.error.length <= 160) return parsed.error;
      if (typeof parsed.message === "string" && parsed.message.length <= 160) {
        return parsed.message;
      }
    } catch {
      /* not JSON */
    }
    return fallback;
  }

  if (text.length > 160) return fallback;
  return text;
}
